export default __webpack_public_path__ + "static/media/36.226b7693.png";